import type { SVGProps } from 'react';

const SvgHMobiledata = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M15 11H9V7H7v10h2v-4h6v4h2V7h-2z" />
  </svg>
);
export default SvgHMobiledata;
